/* IHP cart tools: CPB batch provenance, stale-summary removal and clear cart. */
(function(){
'use strict';
const norm=v=>String(v||'').trim().toLowerCase();
const sorted=o=>Object.fromEntries(Object.entries(o||{}).filter(([k])=>!k.startsWith('_ihp_cpb_')).sort(([a],[b])=>a.localeCompare(b)).map(([k,v])=>[k,String(v)]));
const signature=i=>JSON.stringify([String(i.variant_id||i.id),sorted(i.properties)]);
const summary=i=>i.properties?._ihp_cpb_summary==='1'||norm(i.product_type)==='cpb_hybrid'||(Number(i.price)===0&&/kit/i.test(i.product_title||i.title||'')&&Object.values(i.properties||{}).some(v=>/\[[^\]]+\]\s*x\d+/i.test(String(v))));
const expectedSkus=i=>{
 const counts={};for(const v of Object.values(i.properties||{})){if(typeof v!=='string')continue;for(const m of v.matchAll(/\[([^\]]+)\]\s*x\s*(\d+)/gi))counts[m[1]]=(counts[m[1]]||0)+Number(m[2])*i.quantity;}return counts;
};
function tagPayload(payload,id){
 if(!Array.isArray(payload?.items))return payload;
 const summaries=payload.items.filter(i=>Object.values(i.properties||{}).some(v=>typeof v==='string'&&/thecustomproductbuilder\.com\/(?:private-image|.*orders)/i.test(v))&&Object.values(i.properties||{}).some(v=>/\[[^\]]+\]\s*x\s*\d+/i.test(String(v))));
 if(summaries.length!==1)return payload;
 const parent=summaries[0];
 const group=id;const manifest=payload.items.filter(i=>i!==parent).map(i=>({signature:signature(i),quantity:Number(i.quantity||1)}));
 if(!manifest.length)return payload;
 for(const i of payload.items)i.properties={...i.properties,_ihp_cpb_group:group};
 parent.properties={...parent.properties,_ihp_cpb_summary:'1',_ihp_cpb_manifest:JSON.stringify({quantity:Number(parent.quantity||1),items:manifest})};
 return payload;
}
function invalidSummaries(before,after,changedKeys=[]){
 const bad=[];
 const changed=before.items.filter(i=>changedKeys.includes(i.key));
 const parents=after.items.filter(summary);
 const ungrouped=after.items.filter(i=>!summary(i)&&!i.properties?._ihp_cpb_group);
 for(const parent of parents){
  const group=parent.properties?._ihp_cpb_group;
  if(group){
   let manifest;try{manifest=JSON.parse(parent.properties._ihp_cpb_manifest);}catch{continue;}
   const current=after.items.filter(i=>i!==parent&&i.properties?._ihp_cpb_group===group);
   const totals=list=>{const map={};for(const i of list){const key=i.signature||signature(i);map[key]=(map[key]||0)+Number(i.quantity);}return JSON.stringify(Object.entries(map).sort(([a],[b])=>a.localeCompare(b)));};
   if(Number(parent.quantity)!==manifest.quantity||totals(current)!==totals(manifest.items))bad.push(parent);
  }else{
   const expected=expectedSkus(parent);if(!Object.keys(expected).length)continue;
   const missing=Object.entries(expected).some(([sku,n])=>ungrouped.filter(i=>i.sku===sku).reduce((s,i)=>s+i.quantity,0)<n);
   // Legacy kits have no unique group id. Only identify a changed component when its SKU belongs to exactly one summary.
   const touched=changed.some(i=>{
    if(!i.sku||!expected[i.sku]||parents.filter(p=>expectedSkus(p)[i.sku]).length!==1)return false;
    const current=after.items.find(x=>x.key===i.key);
    return !current||signature(i)!==signature(current)||i.quantity!==current.quantity;
   });
   const editedSummary=changed.some(i=>summary(i)&&(i.key===parent.key||(!after.items.some(n=>n.key===i.key)&&!before.items.some(n=>n.key===parent.key)&&i.variant_id===parent.variant_id))&&(signature(i)!==signature(parent)||i.quantity!==parent.quantity));
   if(missing||touched||editedSummary)bad.push(parent);
  }
 }
 return bad;
}
if(typeof module!=='undefined'&&module.exports){module.exports={tagPayload,invalidSummaries,summary,signature,expectedSkus,parseBody,encode};return;}
if(window.IHPCartTools)return;
const root=window.Shopify?.routes?.root||'/';const originalFetch=window.fetch.bind(window);const originalOpen=XMLHttpRequest.prototype.open;const originalSend=XMLHttpRequest.prototype.send;
const notice=document.getElementById('ihp-kit-edited-dialog');const clearDialog=document.getElementById('ihp-clear-cart-dialog');
let baseline=null,queue=Promise.resolve(),timer,clearInProgress=false,lastFocus=null;
const pendingKey='ihp-kit-edited-notice';
const api=async(path,data)=>{const response=await originalFetch(root+path,{credentials:'same-origin',cache:'no-store',...(data?{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)}:{})});const body=await response.json();if(!response.ok)throw Error(body.description||'Unable to update cart. Please try again.');return body;};
const getCart=()=>api('cart.js');
const initial=document.getElementById('ihp-cart-initial');try{baseline=JSON.parse(initial.textContent);}catch{}
function warning(message){lastFocus=document.activeElement;notice.querySelector('[data-ihp-kit-message]').textContent=message;notice.showModal();}
function rememberNotice(){try{sessionStorage.setItem(pendingKey,'1');}catch{}}
function changedKeys(path,body,before){
 if(/cart\/clear/.test(path))return [];
 if(/cart\/change/.test(path)){
  const i=body?.id?before.items.find(i=>i.key===String(body.id)||String(i.variant_id)===String(body.id)):before.items[Number(body?.line)-1];return i?[i.key]:[];
 }
 if(/cart\/update/.test(path))return Object.keys(body?.updates||{}).map(id=>before.items.find(i=>i.key===id||String(i.variant_id)===id)?.key).filter(Boolean);
 return [];
}
async function reconcile(changed=[]){
 if(clearInProgress)return {changed:false};
 const before=baseline||await getCart(),after=await getCart();
 const invalid=invalidSummaries(before,after,changed);
 if(invalid.length){
  // Remove only the informational $0 CPB hybrid line. Never remove a paid kit or physical component automatically.
  const removable=invalid.filter(i=>Number(i.price)===0&&Number(i.final_price??i.price)===0);
  if(removable.length){
   const updates=Object.fromEntries(removable.map(i=>[i.key,0]));
   const fresh=await api('cart/update.js',{updates});
   if(removable.some(i=>fresh.items.some(n=>n.key===i.key)))throw Error('Unable to remove the outdated kit summary. Please review your cart.');
   baseline=fresh;rememberNotice();location.reload();return {changed:true};
  }
  warning('Your kit changed. Please rebuild it before checking out.');baseline=after;return {changed:true};
 }
 const removedSummary=before.items.some(i=>summary(i)&&changed.includes(i.key)&&!after.items.some(n=>n.key===i.key));
 if(removedSummary){warning('Your kit summary was removed. The remaining products are still in your cart as individual items.');baseline=after;return {changed:true};}
 baseline=after;return {changed:false};
}
function ensure(changed=[]){const job=queue.then(()=>reconcile(changed));queue=job.catch(()=>{});return job;}
const pendingChanges=new Set();
function schedule(changed=[]){for(const key of changed)pendingChanges.add(key);clearTimeout(timer);timer=setTimeout(()=>{const keys=[...pendingChanges];pendingChanges.clear();ensure(keys).catch(()=>warning('We could not check your kit. Please refresh your cart before checking out.'));},120);}
function parseBody(body){
 if(typeof body==='string'){try{return {value:JSON.parse(body),kind:'json'};}catch{}const params=new URLSearchParams(body);return parseParams(params,'url');}
 if(body instanceof URLSearchParams)return parseParams(body,'params');
 if(body instanceof FormData)return parseParams(body,'form');
 return null;
}
function parseParams(params,kind){
 const value={};const items=[];
 for(const [k,v] of params.entries()){
  const m=k.match(/^items\[(\d+)\]\[(id|quantity|properties)\](?:\[([^\]]+)\])?$/);
  if(m){const i=items[Number(m[1])]||(items[Number(m[1])]={});if(m[2]==='properties'){i.properties=i.properties||{};i.properties[m[3]]=v;}else i[m[2]]=v;}
  else{const u=k.match(/^updates\[([^\]]+)\]$/);if(u){value.updates=value.updates||{};value.updates[u[1]]=v;}else value[k]=v;}
 }
 if(items.length)value.items=items;
 return {value,kind,original:params};
}
function encode(parsed){
 if(parsed.kind==='json')return JSON.stringify(parsed.value);
 const output=parsed.kind==='form'?new FormData():new URLSearchParams();
 for(const [k,v] of parsed.original.entries())output.append(k,v);
 for(const [index,i] of (parsed.value.items||[]).entries()){
  for(const [name,value] of Object.entries(i.properties||{}))output.set(`items[${index}][properties][${name}]`,value);
 }
 return parsed.kind==='url'?output.toString():output;
}
const isMutation=path=>/\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/.test(path);
function prepare(path,body){
 const parsed=parseBody(body);const old=baseline;
 if(/\/cart\/add/.test(path)&&parsed){const id=window.crypto?.randomUUID?.()||'ihp-'+Date.now()+'-'+Math.random().toString(36).slice(2);tagPayload(parsed.value,id);body=encode(parsed);}
 return {body,changed:old&&parsed?changedKeys(path,parsed.value,old):[]};
}
window.fetch=async function(input,options){
 const path=typeof input==='string'?input:input?.url||String(input);if(!isMutation(path))return originalFetch(input,options);
 const prep=prepare(path,options?.body);const response=await originalFetch(input,{...options,...options?.body!==undefined&&{body:prep.body}});
 if(response.ok)schedule(prep.changed);return response;
};
XMLHttpRequest.prototype.open=function(method,url,...rest){this._ihpCartUrl=String(url);return originalOpen.call(this,method,url,...rest);};
XMLHttpRequest.prototype.send=function(body){
 if(isMutation(this._ihpCartUrl||'')){const prep=prepare(this._ihpCartUrl,body);body=prep.body;this.addEventListener('load',()=>{if(this.status>=200&&this.status<300)schedule(prep.changed);},{once:true});}
 return originalSend.call(this,body);
};
notice.querySelector('[data-ihp-kit-close]').addEventListener('click',()=>{notice.close();lastFocus?.focus();});
clearDialog.querySelector('[data-ihp-clear-cancel]').addEventListener('click',()=>{if(clearInProgress)return;clearDialog.close();lastFocus?.focus();});
clearDialog.addEventListener('cancel',event=>{if(clearInProgress)event.preventDefault();});
clearDialog.querySelector('[data-ihp-clear-confirm]').addEventListener('click',async()=>{
 if(clearInProgress)return;clearInProgress=true;
 const button=clearDialog.querySelector('[data-ihp-clear-confirm]');button.disabled=true;const status=clearDialog.querySelector('[data-ihp-clear-status]');status.textContent='Clearing cart…';
 try{await queue;clearTimeout(timer);const result=await api('cart/clear.js',{});if(result.items?.length)throw Error('Unable to clear cart. Please try again.');try{sessionStorage.removeItem(pendingKey);}catch{}baseline=result;location.reload();}
 catch(e){status.textContent=e.message;clearInProgress=false;button.disabled=false;}
});
let checkoutPass=false;
document.addEventListener('click',event=>{
 const clear=event.target.closest('[data-ihp-clear-cart]');if(clear){event.preventDefault();lastFocus=clear;clearDialog.querySelector('[data-ihp-clear-status]').textContent='';clearDialog.showModal();return;}
 const target=event.target.closest('[name="checkout"],a[href]');if(!target||checkoutPass||target.disabled)return;
 if(target.tagName==='A'&&!/^\/([^/]+\/)?checkout(?:[/?#]|$)/.test(new URL(target.href,location.origin).pathname))return;
 if(target.tagName!=='A'&&target.name!=='checkout')return;
 event.preventDefault();event.stopImmediatePropagation();ensure().then(result=>{if(result.changed)return;checkoutPass=true;try{target.click();}finally{checkoutPass=false;}}).catch(()=>warning('We could not check your kit. Please refresh your cart before checking out.'));
},true);
// Catch keyboard form checkout too, before the compatibility handler.
let submitPass=false;
document.addEventListener('submit',event=>{
 if(event.submitter?.name!=='checkout'||submitPass)return;event.preventDefault();event.stopImmediatePropagation();
 const form=event.target,submitter=event.submitter;ensure().then(result=>{if(result.changed)return;submitPass=true;try{form.requestSubmit(submitter);}finally{submitPass=false;}}).catch(()=>warning('We could not check your kit. Please refresh your cart before checking out.'));
},true);
if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,()=>schedule());
window.IHPCartTools={ensure};
try{if(sessionStorage.getItem(pendingKey)){sessionStorage.removeItem(pendingKey);warning('Your kit was changed. We removed its outdated kit summary. The remaining products are still in your cart.');}}catch{}
// Validate the first cart view as well, including stale legacy summaries.
ensure().catch(()=>{});
})();
